// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/EntityFinancials/AddFinancialsModal.css */

.modal-content.modal-financials {
  min-width: 500px;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-content.modal-financials h3 {
  color: #F39C12;
  border-bottom: 2px solid #F39C12;
  padding-bottom: 12px;
}

.modal-financials .form-section {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ECF0F1;
}

.modal-financials .form-section:last-of-type {
  border-bottom: none;
}

.modal-financials .form-section h4 {
  margin: 0 0 12px 0;
  color: #7F8C8D;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modal-financials .form-row {
  display: flex;
  gap: 12px;
}

.modal-financials .form-row .form-group {
  flex: 1 1;
}

.modal-financials .form-group {
  margin-bottom: 12px;
}

.modal-financials .form-group label {
  display: block;
  margin-bottom: 6px;
  color: #34495E;
  font-size: 14px;
  font-weight: 500;
}

.modal-financials .form-group input[type="number"],
.modal-financials .form-group select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #BDC3C7;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.modal-financials .form-group input:focus,
.modal-financials .form-group select:focus {
  outline: none;
  border-color: #F39C12;
  box-shadow: 0 0 0 2px rgba(243, 156, 18, 0.2);
}

.modal-financials .checkbox-group {
  display: flex;
  align-items: center;
  padding-top: 28px;
}

.modal-financials .checkbox-group label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin-bottom: 0;
}

.modal-financials .checkbox-group input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

/* Calculation preview */
.modal-financials .calculation-preview {
  background-color: #FEF9E7;
  margin: 16px -24px;
  padding: 16px 24px !important;
  border-radius: 0;
}

.modal-financials .calculation-preview h4 {
  color: #D68910 !important;
}

.modal-financials .calculation-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
}

.modal-financials .calculation-row .value {
  font-weight: 600;
  font-family: 'Monaco', 'Menlo', monospace;
}

.modal-financials .calculation-row .value.positive {
  color: #27AE60;
}

.modal-financials .calculation-row .value.negative {
  color: #E74C3C;
}

.modal-financials .calculation-row.result {
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid #F5D89A;
}

.modal-financials .calculation-row.result .value {
  font-size: 16px;
}

/* Buttons */
.modal-financials .modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.save-btn-financials {
  background-color: #F39C12 !important;
}

.save-btn-financials:hover {
  background-color: #D68910 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/EntityFinancials/AddFinancialsModal.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["/* src/components/EntityFinancials/AddFinancialsModal.css */\n\n.modal-content.modal-financials {\n  min-width: 500px;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal-content.modal-financials h3 {\n  color: #F39C12;\n  border-bottom: 2px solid #F39C12;\n  padding-bottom: 12px;\n}\n\n.modal-financials .form-section {\n  margin-bottom: 20px;\n  padding-bottom: 15px;\n  border-bottom: 1px solid #ECF0F1;\n}\n\n.modal-financials .form-section:last-of-type {\n  border-bottom: none;\n}\n\n.modal-financials .form-section h4 {\n  margin: 0 0 12px 0;\n  color: #7F8C8D;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.modal-financials .form-row {\n  display: flex;\n  gap: 12px;\n}\n\n.modal-financials .form-row .form-group {\n  flex: 1;\n}\n\n.modal-financials .form-group {\n  margin-bottom: 12px;\n}\n\n.modal-financials .form-group label {\n  display: block;\n  margin-bottom: 6px;\n  color: #34495E;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.modal-financials .form-group input[type=\"number\"],\n.modal-financials .form-group select {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #BDC3C7;\n  border-radius: 4px;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\n.modal-financials .form-group input:focus,\n.modal-financials .form-group select:focus {\n  outline: none;\n  border-color: #F39C12;\n  box-shadow: 0 0 0 2px rgba(243, 156, 18, 0.2);\n}\n\n.modal-financials .checkbox-group {\n  display: flex;\n  align-items: center;\n  padding-top: 28px;\n}\n\n.modal-financials .checkbox-group label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  margin-bottom: 0;\n}\n\n.modal-financials .checkbox-group input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n/* Calculation preview */\n.modal-financials .calculation-preview {\n  background-color: #FEF9E7;\n  margin: 16px -24px;\n  padding: 16px 24px !important;\n  border-radius: 0;\n}\n\n.modal-financials .calculation-preview h4 {\n  color: #D68910 !important;\n}\n\n.modal-financials .calculation-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 0;\n}\n\n.modal-financials .calculation-row .value {\n  font-weight: 600;\n  font-family: 'Monaco', 'Menlo', monospace;\n}\n\n.modal-financials .calculation-row .value.positive {\n  color: #27AE60;\n}\n\n.modal-financials .calculation-row .value.negative {\n  color: #E74C3C;\n}\n\n.modal-financials .calculation-row.result {\n  margin-top: 8px;\n  padding-top: 12px;\n  border-top: 1px solid #F5D89A;\n}\n\n.modal-financials .calculation-row.result .value {\n  font-size: 16px;\n}\n\n/* Buttons */\n.modal-financials .modal-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.save-btn-financials {\n  background-color: #F39C12 !important;\n}\n\n.save-btn-financials:hover {\n  background-color: #D68910 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
